/* eslint-disable react/button-has-type */
// after reading in online source, it seems eslint is buggy

import React from 'react';
import { DefaultIcon, GradientIcon } from '../../../atoms/icons';

interface Props {
    id: string
    onClick?: React.MouseEventHandler<HTMLButtonElement> | undefined
    disabled?: boolean
    className?: string | undefined
    type?: 'button' | 'submit' | 'reset'
    icon : React.ReactElement<DefaultIcon> | React.ReactElement<GradientIcon>
    isButton?: boolean;
}

const CircleIcon:React.FC<Props> = (props) => {
  const {
    id, onClick, icon,
    type = 'button',
    disabled = false,
    isButton = false,
    className,
  } = props;
  if (isButton) {
    return (
      <button
        id={id}
        type={type}
        disabled={disabled}
        className={`border-0 rounded-circle flexible-center bg-dark ${className}`}
        style={{ width: '35px', height: '35px' }}
        onClick={onClick}
      >
        <div style={{ marginBottom: '2px' }}>
          {icon}
        </div>
      </button>
    );
  }
  return (
    <div
      id={id}
      className={`border-0 rounded-circle flexible-center bg-dark ${className}`}
      style={{ width: '35px', height: '35px' }}
    >
      <div style={{ marginBottom: '2px' }}>
        {icon}
      </div>
    </div>
  );
};

export default CircleIcon;
